import { schemas } from '@repo/contracts'
import { parseDataOfType } from '@/common/parseDataType'
import { apiErrorHandler } from '../errorHandler'
import type { z } from 'zod'

// SalesChannel wire values (from the Go SalesChannel.String()); kept as a named
// export for consumers that reference the channel by name.
export const SalesChannel = {
  Stripe: 'Stripe',
  AwsMarketplace: 'AWS_Marketplace',
  Direct: 'Direct',
  Unknown: 'Unknown'
} as const

export type SalesChannel = (typeof SalesChannel)[keyof typeof SalesChannel]

export const UserOrgProfileSchema = schemas.apihttp_ProfileResponse
export type UserOrgProfile = z.infer<typeof schemas.apihttp_ProfileResponse>

export async function apiUserOrgProfile(): Promise<UserOrgProfile> {
  const res = await fetch(`${window.location.origin}/api/user/profile`, {
    method: 'GET',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
  return parseDataOfType(await res.json(), UserOrgProfileSchema)
}

export async function apiRestoreUserOrgProfile(): Promise<UserOrgProfile | undefined> {
  const res = await fetch(`${window.location.origin}/api/user/profile`, {
    method: 'GET',
    credentials: 'same-origin'
  })
  if (res.status === 401) {
    await res.body?.cancel()
    return undefined
  }
  await apiErrorHandler(res)
  return parseDataOfType(await res.json(), UserOrgProfileSchema)
}

export type UpdateProfileRequest = z.infer<typeof schemas.apihttp_UpdateProfileRequest>

export async function apiUpdateProfile(data: UpdateProfileRequest): Promise<void> {
  const req = parseDataOfType(data, schemas.apihttp_UpdateProfileRequest)
  const res = await fetch(`${window.location.origin}/api/user/profile`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req)
  })
  await apiErrorHandler(res)
}
